export const ADD_CONTENT_EDITOR = "ADD_CONTENT_EDITOR"
export const ADD_CONTENT_EDITOR_SUCCESS = "ADD_CONTENT_EDITOR_SUCCESS"
export const ADD_CONTENT_EDITOR_FAIL = "ADD_CONTENT_EDITOR_FAIL"
export const CLEAR_CONTENT_EDITOR = "CLEAR_CONTENT_EDITOR"